// © Copyright 2026 Emman Consulting SAS
import React, { useState } from "react";
import { CC_PLAYERS, CC_TOTAL } from "../../data/albumData.js";
import { I18N } from "../../i18n.js";
import { useLongPress } from "../../hooks/useLongPress.js";
import FlagImg from "../ui/FlagImg.jsx";

const CcSection = React.memo(function CcSection({ col, onTap, onReset, filter, lang }) {
  const t = I18N[lang || "es"];
  const [open, setOpen] = useState(false);
  const owned = CC_PLAYERS.filter((s) => col[s.code]?.owned).length;
  const pct = Math.round(owned / CC_TOTAL * 100);
  const { handlers } = useLongPress({ onTap, onReset });

  return (
    <div className="ccbox-simple">
      <div className="gbg" />
      <div className="gwave" />
      <div className="ginner">
        <div className="fwchdr" onClick={() => setOpen((o) => !o)}>
          <div className="fwchl">
            <div>
              <div className="fwcttl">{t.ccTitle}</div>
              <div className="fwcsub">{t.ccSub}</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ textAlign: "right" }}>
              <span className="fwcpill">{pct}%</span>
              <div className="gcnt">{owned}/{CC_TOTAL}</div>
            </div>
            <span className={"chv" + (open ? " open" : "")}>▼</span>
          </div>
        </div>
        {open && (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: "12px 16px" }}>
            {CC_PLAYERS.map((s) => {
              const st = col[s.code] || { owned: false, quantity: 0 };
              const isDupe = st.owned && st.quantity > 0;
              if (filter === "missing" && st.owned) return null;
              if (filter === "dupes" && !isDupe) return null;
              if (filter === "owned" && !st.owned) return null;
              return (
                <div
                  key={s.code}
                  className={"ccrow" + (isDupe ? " dupe" : st.owned ? " owned" : "")}
                  {...handlers(s.code)}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
                    <FlagImg cc={s.cc} style={{ width: 24, height: 16, borderRadius: 3, flexShrink: 0 }} />
                    <div>
                      <div className="ccname">{s.label}</div>
                      <div className="cccountry">{lang === "en" ? (s.countryEn || s.country) : s.country}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {isDupe && <span className="ccbadge">×{st.quantity}</span>}
                    {st.owned && <span className="cccheck">✓</span>}
                    {!st.owned && <span className="ccempty" />}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
});

export default CcSection;
